module.exports = __webpack_public_path__ + "static/img/e2e5cf21eac68fe90d2c01b994fcd22e.09028bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/e2e5cf21eac68fe90d2c01b994fcd22e.jpg
// module id = U1bN
// module chunks = 3